module.exports = __webpack_public_path__ + "static/img/advantage5.139458fb.png";